import { render, staticRenderFns } from "./SectionMessages.vue?vue&type=template&id=3748a14c&scoped=true&"
import script from "./SectionMessages.vue?vue&type=script&lang=js&"
export * from "./SectionMessages.vue?vue&type=script&lang=js&"
import style0 from "./SectionMessages.vue?vue&type=style&index=0&id=3748a14c&lang=scss&scoped=true&"
import style1 from "./SectionMessages.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748a14c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
